import React from 'react';

const INTEGRATIONS = ['Shopify', 'PrestaShop', 'WhatsApp', 'Klaviyo', 'Brevo'];

export function IntegrationsMarquee() {
  const items = [...INTEGRATIONS, ...INTEGRATIONS];

  return (
    <div data-testid="landing-integrations-marquee" className="relative py-10 overflow-hidden">
      <p className="text-center text-xs uppercase tracking-widest text-zinc-500 mb-6">
        Compatible nativamente con tu ecosistema
      </p>
      <div className="relative overflow-hidden mask-fade">
        <div className="sera-marquee-track">
          {items.map((name, i) => (
            <span
              key={`${name}-${i}`}
              className="mx-10 text-2xl md:text-3xl font-bold text-zinc-600 whitespace-nowrap"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
